import { MapIcon, XIcon } from 'lucide-react';
import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

type WizardHeaderProps = {
  disabled?: boolean;
  label: string;
  closeModal: () => void;
};

export const WizardHeader: FC<WizardHeaderProps> = ({ disabled = false, label, closeModal }) => {
  const { t } = useTranslation();

  return (
    <header className="flex items-start justify-between border-b px-6 py-5">
      <div className="flex items-start gap-3">
        <MapIcon className="mt-1 size-5 text-primary-light" />
        <div>
          <h2 className="text-lg font-bold text-primary-dark">{label}</h2>
          <p className="mt-1 text-base font-medium text-slate-500">
            {t('quicklyAddFloorPlanToAnyEstate')}
          </p>
        </div>
      </div>
      <button
        type="button"
        className="rounded-full p-1 text-slate-500 transition-colors hover:bg-slate-100 hover:text-slate-700 disabled:pointer-events-none disabled:opacity-50"
        disabled={disabled}
        onClick={closeModal}
        aria-label={t('close')}
      >
        <XIcon className="size-5 text-slate-500" />
      </button>
    </header>
  );
};
